<template>
  <mdb-carousel class="wr" :interval="6000" slide :items="items" controlls />
</template>

<script>
export default {
  name: 'mbCarouselMain',
  data() {
    return {
      items: [
        {
          img: true,
          src: '/static/images/mainimg/mbhalfmain88.png',
        },
        {
          img: true,
          src: '/static/images/mainimg/mbhalfmain3.png',
        },
        {
          img: true,
          src: '/static/images/mainimg/mbhalfmain2.png',
        },
      ],
    };
  },
};
</script>

<style scoped>
.container-fluid {
  max-width: 100%;
  height: auto;
  padding-left: 0px;
  margin-right: 0px;
  margin-left: 0px;
}

.wr {
  max-width: 100%;
  max-height: 100%;
  margin: 0 0px;
  padding: 0 0px;
}
</style>
